/**
 * Formats a percentage number for display without a `%` suffix.
 * Keeps up to two decimal places so API values like `1.11` stay `1.11`.
 * Non-finite input becomes `"0"`.
 */
export function formatPercentNumber(value: unknown): string {
  const n = Number(value)
  if (!Number.isFinite(n)) return '0'
  const rounded = Math.round(n * 100) / 100
  return Number.isInteger(rounded) ? String(rounded) : String(rounded)
}
